import { LocationModel } from '../ts/interfaces/models/LocationModel';
import { BaseService } from './baseService';

class LocationService extends BaseService<LocationModel> {
  controllerName = 'location';
}

export const locationService = new LocationService();
